import { RootState } from '@/shared/store'

import { webAdminsAdapter } from './webAdminsAdapters'

export const webAdminsSelectors = webAdminsAdapter.getSelectors<RootState>(
  (state) => state.webAdmins,
)
